import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { GraphemeInfoFlashcardSurface } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels";
import { LearnFlashcardSurfaceReadyMarker } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";
import { NewMorphemeLessonLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._context";

/** The reference panel for the lesson's character, as a deck card surface. */
export function LessonFlashcardInfo() {
  const [grapheme] = useContextSelectors(NewMorphemeLessonLayoutContext, (c) => c.grapheme);
  return (
    <GraphemeInfoFlashcardSurface grapheme={grapheme}>
      <LearnFlashcardSurfaceReadyMarker />
    </GraphemeInfoFlashcardSurface>
  );
}
